(function ($) {

    $.fn.PasswordRevealer = function () {
        var passwordField = this,
            passwordRevealButton = $('<div class="passwordRevealer pull-right"><i class="fa fa-eye" aria-hidden="true"></i></div>');

        // Append the show/hide button.
        passwordField.after(passwordRevealButton);

        console.log("working?")

        // Click event for the password reveal.
        $('.passwordRevealer')
            .off()
            .on('click', function () {
                if ($(this).parent().find('input').attr('type') === 'text') {
                    $(this).parent().find('input').attr('type', 'password');
                    $(this).find('i').removeClass('fa-eye-slash').addClass('fa-eye');
                } else {
                    $(this).parent().find('input').attr('type', 'text');
                    $(this).find('i').removeClass('fa-eye').addClass('fa-eye-slash');
                }
            });
    };
})($);